import { useState, useEffect } from 'react';
import Navigation from './Navigation';

export default function Hero() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/b789a6ddee46a2f2ea1daa7b6511792e.jpg"
          alt="Professional Auto Parts Workshop"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-black/70 via-black/50 to-black/60"></div>
      </div>

      <Navigation scrolled={scrolled} />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-32">
        <div className="max-w-3xl">
          <h1 className="font-rajdhani font-bold text-white mb-6 leading-tight">
            <span className="text-5xl md:text-7xl block">QUALITY AUTO PARTS</span>
            <span className="text-3xl md:text-4xl block mt-2">at Discount Prices – Trusted for Over 20 Years</span>
          </h1>

          <p className="text-lg md:text-xl text-white/80 mb-8 font-inter">
            Serving Mississauga &amp; GTA with reliable auto parts and expert installation.
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10">
            {[
              '20+ Years Experience',
              'Thousands of Happy Customers',
              'Competitive Pricing',
              'Professional Installation Available'
            ].map((badge, index) => (
              <div key={index} className="flex items-center gap-2 bg-black/40 backdrop-blur-sm px-4 py-3 rounded-lg">
                <div className="w-6 h-6 flex items-center justify-center bg-red-600 rounded-full flex-shrink-0">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <span className="text-white text-sm font-medium">{badge}</span>
              </div>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="tel:905-226-0408"
              className="inline-flex items-center justify-center gap-3 bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-full font-rajdhani font-bold text-lg transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-fill text-xl"></i>
              CALL NOW – 905-226-0408
            </a>
            <a
              href="#quote"
              className="inline-flex items-center justify-center gap-2 bg-transparent border-2 border-white hover:bg-white hover:text-black text-white px-8 py-4 rounded-full font-rajdhani font-bold text-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Get Free Quote
              <i className="ri-arrow-right-line text-xl"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
